import styledComponents from 'styled-components'

export default styledComponents.div.attrs({ className: 'container ' })``



// WEBPACK FOOTER //
// ./src/components/views/layouts/Container.js